import React from 'react';
import Hero from '../components/home/Hero';
import ServicePlans from '../components/home/ServicePlans';
import Testimonials from '../components/home/Testimonials';
import BrandCarousel from '../components/home/BrandCarousel';
import WhyChooseUs from '../components/home/WhyChooseUs';
import SoftServiceSection from '../components/home/SoftServiceSection';
const Home = () => {
  return <div className="min-h-screen bg-white" data-id="element-401">
      <Hero data-id="element-402" />
      <ServicePlans data-id="element-403" />
      <SoftServiceSection data-id="element-404" />
      <BrandCarousel data-id="element-405" />
      <WhyChooseUs data-id="element-406" />
      <Testimonials data-id="element-407" />
    </div>;
};
export default Home;